import { updatePlayerDisplayName } from "@dailywars/core/db";
import { DisplayNameTakenError, InvalidDisplayNameError } from "@dailywars/core/errors";
import { createServerFn } from "@tanstack/react-start";

import { updateDisplayNameInputSchema } from "#/lib/playerSettingsSchemas";
import { getRequestLogger, logRequestError } from "#/lib/requestLogger.server";
import { authedMiddleware } from "#/server/authedMiddleware";
import { displayNameTakenError, invalidDisplayNameError } from "#/server/errors";

export const updateMyDisplayName = createServerFn({ method: "POST" })
  .middleware([authedMiddleware])
  .validator(updateDisplayNameInputSchema)
  .handler(async ({ context, data }) => {
    getRequestLogger().set({ profile: { action: "update_display_name" } });

    try {
      await updatePlayerDisplayName(context.userId, data.displayName);
    } catch (error) {
      if (error instanceof InvalidDisplayNameError) {
        throw invalidDisplayNameError(error.message);
      }
      if (error instanceof DisplayNameTakenError) {
        throw displayNameTakenError();
      }
      logRequestError({
        log: getRequestLogger(),
        error,
        context: { profile: { step: "update_display_name" } },
      });
      throw error;
    }
  });
